export default [{
    id: "82601",
    name: "Moorfields Eye Hospital",
},
{
    id: "82602",
    name: "NHS Foundation Trust - Royal Hallamshire Hospital",
},
/*
{
    id: "82603",
    name: "Liverpool University Hospital Foundation Trust",
}, 
*/];